export const GATE_TYPES = [
    'Banana',
    'Jump gate',
    'Jump gate + Side gate',
    'Side gate',
    'Submarine',
    'Cut gate',
    'Pin Point gate',
    'Pin Point gate + Side Gate',
    'Pin Point gate + Side Gate + Submarine',
]